import React from "react";
import { motion } from "framer-motion";
import { ASSETS, MENU_URL } from "../lib/api";
import { Embers, SmokeParticles } from "./SmokeParticles";
import { useT } from "../i18n/LanguageContext";

export const CTAFinal = ({ onReserve }) => {
  const { t } = useT();
  const x = t.ctafinal;
  return (
    <section className="relative section-pad section-pad-top-tight section-pad-bottom-tight overflow-hidden" data-testid="cta-final-section">
      <div className="absolute inset-0">
        <img src={ASSETS.ingresso} alt="" className="w-full h-full object-cover opacity-25" />
        <div className="absolute inset-0 bg-gradient-to-b from-[var(--pn-black)] via-[var(--pn-black)]/85 to-[var(--pn-black)]" />
      </div>
      <Embers count={10} />
      <SmokeParticles count={3} />
      <div className="absolute inset-0 grain pointer-events-none" />

      <div className="relative max-w-[1080px] mx-auto text-center">
        <motion.span
          initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }}
          transition={{ duration: 0.7 }} className="eyebrow"
        >
          {x.eyebrow}
        </motion.span>
        <motion.h2
          initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
          transition={{ duration: 1.2, ease: [0.22, 0.61, 0.36, 1] }}
          className="mt-6 font-display font-light text-[40px] sm:text-[56px] md:text-[82px] lg:text-[100px] leading-[0.98] tracking-[-0.015em] text-[var(--pn-milk)]"
        >
          {x.title_a}<em className="italic text-[var(--pn-amber)]">{x.title_b}</em>
        </motion.h2>
        <motion.div
          initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
          transition={{ delay: 0.3, duration: 1 }} className="mt-10 max-w-[600px] mx-auto"
        >
          <p className="font-display italic text-[18px] md:text-[22px] leading-[1.55] text-[var(--pn-cream)]/90">
            {x.pull_a}<br />{x.pull_b}
          </p>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
          transition={{ delay: 0.5, duration: 1 }}
          className="mt-14 flex flex-col sm:flex-row gap-4 justify-center items-center"
        >
          <a
            href="https://pnssm.pro/5sq02s5"
            target="_blank"
            rel="noopener noreferrer"
            className="cta-primary"
            data-testid="ctafinal-reserve"
          >
            {x.ctaReserve}<span aria-hidden>→</span>
          </a>
          <a href={MENU_URL} target="_blank" rel="noopener noreferrer"
            className="cta-secondary" data-testid="ctafinal-menu"
          >
            {x.ctaMenu}
          </a>
        </motion.div>
      </div>
    </section>
  );
};
